/**
 * Do not edit directly.
 * Generated via Design Token Pipeline
 */
import React from 'react';
import { convertIconPropsToSvgProps } from '../../utils';
export const IconConfirmationOutline = React.forwardRef((iconProps, ref) => {
    const props = convertIconPropsToSvgProps({
        ...iconProps,
        'aria-label': 'icon-confirmation-outline',
    });
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ref: ref, ...props },
        React.createElement("path", { d: "m11.487 13.102.478.478.44-.514 6.618-7.735.001-.001c.142-.163.282-.206.405-.205.14 0 .303.06.445.181.141.12.224.27.246.406.018.116-.002.26-.145.428l-7.498 8.763-.001.001a.622.622 0 0 1-.917.037l-3.75-3.754-.001-.002c-.158-.156-.19-.3-.181-.42a.7.7 0 0 1 .213-.426.706.706 0 0 1 .428-.215c.121-.01.266.022.424.178l2.795 2.8Zm3.44-10.012c.237.078.34.202.388.315a.664.664 0 0 1 .005.467.688.688 0 0 1-.29.378c-.11.064-.266.101-.491.027h-.001A8.168 8.168 0 0 0 12 3.875c-4.482 0-8.125 3.643-8.125 8.125S7.518 20.125 12 20.125s8.125-3.643 8.125-8.125a7.95 7.95 0 0 0-.049-.887c-.035-.856 1.133-.954 1.24-.149.037.343.059.69.059 1.04 0 5.166-4.204 9.371-9.375 9.371-5.17 0-9.375-4.205-9.375-9.375S6.83 2.625 12 2.625c1 0 1.986.158 2.927.465Z", strokeWidth: 1.25 })));
});
IconConfirmationOutline.displayName = 'IconConfirmationOutline';
export default IconConfirmationOutline;
